import { withTranslation } from 'react-i18next';
import ConfirmModal from '@components/ConfirmModal';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import { IAvaturnRevokeConsentModal } from './interfaces';

const AvaturnRevokeConsentModal = ({
  open,
  t: translate,
  onClose,
  onConfirm,
}: IAvaturnRevokeConsentModal) => {
  return (
    <ConfirmModal
      icon={<PriorityHighIcon />}
      open={open}
      title={translate('revokeCustomAvaturnConsent.modal.title')}
      message={translate('revokeCustomAvaturnConsent.modal.message')}
      confirmButtonName={translate(
        'revokeCustomAvaturnConsent.modal.yesWithdraw',
      )}
      onConfirm={onConfirm}
      onCancel={onClose}
    />
  );
};

export default withTranslation()(AvaturnRevokeConsentModal);
